module.exports = __webpack_public_path__ + "media/images/front/materiales_mid-36bf4480cafcb494d4f1ec6ddb06234a.png";